const initialState = {
  data: null,
  userList: [],
  isLoading: false,
  error: "",
  editSuccess: false,
  editError: "",
  addSuccess: false,
  addError: "",
  updateSuccess: false,
  updateError: "",
  fetchMissingData: [],
  fetchDataSuccess: false,
  fetchDataFailure: false,
  fetchFloorDataSuccess: false,
  fetchFloorDataFailure: false,
  fetchFloorData: [],
  selectedFloor: null,
  deleteItemFail: false,
  floorId: 0,
  buildingData: [],
  buildingDataLoading: false,
  buildingDataError: "",
};

const FloorManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_LIST_LOADING":
    case "DELETE_FLOOR_LOADING":
    case "FLOOR_LIST_LOADING":
      return {
        ...state,
        isLoading: true,
        error: "",
      };

    case "FLOOR_LIST_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: "",
      };

    case "FLOOR_LIST_ERROR":
    case "DELETE_FLOOR_ERROR":
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case "DELETE_FLOOR_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: state.data.filter((floor) => floor.id !== action.payload),
      };
    case "GET_USER_LIST_SUCCESS":
      return {
        ...state,
        isLoading: false,
        userList: action.payload,
        error: "",
      };

    case "ADD_FLOOR_SUCCESS":
      return {
        ...state,
        isLoading: false,
        error: "",
        addSuccess: true,
      };
    case "ADD_FLOOR_ERROR":
      return {
        ...state,
        error: action.payload,
        addSuccess: false,
      };

    case "EDIT_FLOOR_ERROR":
      return {
        ...state,
        error: action.payload,
        editSuccess: false,
      };
    case "EDIT_FLOOR_LOADING":
      return {
        ...state,
        isLoading: true,
        editSuccess: false, // Reset success flag
        editError: "", // Reset error
        error: "",
      };

    case "ADD_FLOOR_LOADING":
      return {
        ...state,
        isLoading: true,
        addSuccess: false, // Reset success flag
        addError: "", // Reset error
        error: "",
      };
    case "EDIT_FLOOR_SUCCESS":
      return {
        ...state,
        error: "",
        editSuccess: true,
      };
    case "UPDATE_DEVICE_LOADING":
      return {
        ...state,
        isLoading: true,
        updateSuccess: false,
        updateError: "",
      };

    case "UPDATE_DEVICE_SUCCESS":
      return {
        ...state,
        isLoading: false,
        updateSuccess: true,
        data: state.data.map((device) =>
          device.id === action.payload.id
            ? { ...device, ...action.payload }
            : device
        ),
        updateError: "",
      };

    case "UPDATE_DEVICE_ERROR":
      return {
        ...state,
        isLoading: false,
        updateError: action.payload,
      };
    case "FETCH_DEVICES_SUCCESS":
      return {
        ...state,
        fetchDataSuccess: true,
        fetchMissingData: action.payload,
      };
    case "FETCH_DEVICES_FAILURE":
      return {
        ...state,
        fetchDataFailure: true,
      };
    case "FETCH_FLOOR_DEVICES_SUCCESS":
      return {
        ...state,
        fetchFloorDataSuccess: true,
        fetchFloorData: action.payload,
      };
    case "FETCH_FLOOR_DEVICES_FAILURE":
      return {
        ...state,
        fetchFloorDataFailure: true,
      };
    case "RESET_MISSING_DEVICE":
      return {
        ...state,
        fetchDataSuccess: false,
        fetchDataFailure: false,
      };
    case "FETCH_FLOOR_REQUEST":
      return { ...state, isLoading: true, error: null };
    case "FETCH_FLOOR_SUCCESS":
      return { ...state, isLoading: false, selectedFloor: action.payload };
    case "FETCH_FLOOR_FAILURE":
      return { ...state, isLoading: false, error: action.error };
    case "DELETE_ITEM_FAILURE":
      return { ...state, deleteItemFail: true };
    case "UPDATED_FLOOR_ID":
      return { ...state, floorId: action.payload };
    case "FETCH_BUILDING_DATA_LOADING":
      return {
        ...state,
        buildingDataLoading: true,
        buildingDataError: "",
      };
    case "FETCH_BUILDING_DATA_SUCCESS":
      return {
        ...state,
        buildingDataLoading: false,
        buildingData: action.payload,
        buildingDataError: "",
      };
    case "FETCH_BUILDING_DATA_ERROR":
      return {
        ...state,
        buildingDataLoading: false,
        buildingDataError: action.payload,
      };
    case "CLEAR_FLOOR_ERRORS":
      return {
        ...state,
        error: null,
        editError: null,
        addError: null,
        editSuccess: false, // Add this
        addSuccess: false, // Add this
      };
    default:
      return state;
  }
};

export default FloorManagementReducer;
